module.exports = __webpack_public_path__ + "img/bz4.2a5857ee.png";